import SkeletonBlock from './SkeletonBlock';

const WHEEL_COLUMN_COUNT = 3;

const SkeletonTimeWheelPicker = () => (
  <div className='w-fit h-fit rounded-md border border-secondary-400/60 bg-primary-50 dark:bg-secondary-dark-200 p-1 flex items-center ~gap-0.5/1'>
    {Array.from({ length: WHEEL_COLUMN_COUNT }).map((_, index) => (
      <SkeletonBlock
        key={index}
        className='~w-8/10 ~h-10/12 border-0 bg-primary-100 dark:bg-secondary-dark-300'
      />
    ))}
  </div>
);

export default SkeletonTimeWheelPicker;
